import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CorporateService } from 'src/app/services/corporate.service';

@Component({
  selector: 'app-enable-disable-jdn',
  templateUrl: './enable-disable-jdn.component.html',
  styleUrls: ['./enable-disable-jdn.component.css']
})
export class EnableDisableJDNComponent implements OnInit {
  jdnStatus = '';
  api_success: string;
  api_error: any;
  disableChangeStatusbtn = false;
  currentJDNStatus: any;
  corpId: any;
  formVal: any;

  constructor(private corporateService: CorporateService, @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<any>) { }

  ngOnInit() {
    this.currentJDNStatus = this.data['jdnstatus'];
    this.corpId = this.data['corporate'].corporateId;
    this.formVal = this.data['formValue'];
    if (this.currentJDNStatus === 'ENABLED') {
      this.jdnStatus = 'DISABLE';
    } else if (this.currentJDNStatus === 'DISABLED') {
      this.jdnStatus = 'ENABLE';
    }
  }
  onChangeStatus() {

    if (this.currentJDNStatus === 'ENABLED') {
      this.disableJDN();
    } else if (this.currentJDNStatus === 'DISABLED') {
      this.enableJDN();
    }
  }


  enableJDN() {
    this.disableChangeStatusbtn = true;
    this.corporateService.enableJDN(this.corpId, this.formVal)
      .subscribe(res => {
        this.api_success = 'JDN Updated Successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
        }, 2000);
      }, (error) => {
        this.api_error = error.error;
        this.disableChangeStatusbtn = false;
      });
  }
  disableJDN() {
    this.disableChangeStatusbtn = true;
    this.corporateService.disableJDN(this.corpId)
      .subscribe(res => {
        this.api_success = 'JDN disabled Successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
        }, 2000);
      }, (error) => {
        this.api_error = error.error;
        this.disableChangeStatusbtn = false;
      });
  }

}
